// extracted by mini-css-extract-plugin
export var SpinnerWrapper = "Loading-module--SpinnerWrapper--2rc_1";
export var Spinner = "Loading-module--Spinner--3nVtu";
export var rotate = "Loading-module--rotate--Igl0Q";
export var Path = "Loading-module--Path--3w6Q3";
export var dash = "Loading-module--dash--2OaU-";